import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Container = styled.div`
  overflow: hidden;
  margin-bottom: 40px;
`

export const TitleWrapper = styled.div`
  margin-left: ${tokens.spacing.horizontalXsmall};
`

export const BooksWrapper = styled.div`
  display: flex;
  gap: ${tokens.spacing.horizontalLarge};
  margin: 10px ${tokens.spacing.horizontalXsmall};
`
